import { render } from "./_chart-pie.vue?vue&type=template&id=38965959"
import script from "./_chart-pie.vue?vue&type=script&lang=js"
export * from "./_chart-pie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__